import { connect } from 'react-redux';

import { createErrorBanner } from 'components/Banner';
import { openModal as openModalAction } from 'components/Modal';
import Segment from 'helpers/segment';
import { selectActiveVenueId, selectUserInfo } from 'selectors/general';
import { selectIsDesktop, selectIsMobile } from 'selectors/ui';

import Integrations from './Integrations';

const mapStateToProps = state => {
  const { locale } = selectUserInfo(state);
  const venueId = selectActiveVenueId(state);

  return {
    isDesktop: selectIsDesktop(state),
    isMobile: selectIsMobile(state),
    locale,
    venueId,
  };
};

const mapDispatchToProps = {
  createErrorBanner,
  openModal: openModalAction,
};

const mergeProps = (stateProps, dispatchProps) => {
  const { openModal, ...restDispatchProps } = dispatchProps;
  const { venueId, ...restStateProps } = stateProps;

  const onIntegratorCardClick = ({ description, guideLink, logoImageUrl, name, sfdcApiValue }) => {
    Segment.event('Click Integrator Card', { integratorName: name, venueId });
    return openModal('IntegrationRequestModal', {
      description,
      guideLink,
      integratorName: name,
      logoImageUrl,
      sfdcApiValue,
    });
  };

  return {
    ...restDispatchProps,
    ...restStateProps,
    onIntegratorCardClick,
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Integrations);
